import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["getButtonAttributes", "getButtonDisabled", "getButtonLabel", "getButtonOnClick", "getButtonRef", "getButtonTagName", "buttons", "className"];
import { cnBem } from '@carnica/utils';
import React from 'react';
import { withRenderFlag } from '@beef/react';
import { Button } from "../../Button";
import styles from "./styles.pcss";
var cnStatusViewButtons = cnBem('status-view-buttons', styles);
var StatusViewButtonsRender = function StatusViewButtonsRender(_ref) {
  var getButtonAttributes = _ref.getButtonAttributes,
    getButtonDisabled = _ref.getButtonDisabled,
    getButtonLabel = _ref.getButtonLabel,
    getButtonOnClick = _ref.getButtonOnClick,
    getButtonRef = _ref.getButtonRef,
    getButtonTagName = _ref.getButtonTagName,
    _ref$buttons = _ref.buttons,
    buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnStatusViewButtons(null, [className])
  }, otherProps, {
    "data-t-id": "StatusView-StatusViewButtons"
  }), buttons.map(function (button, i) {
    return /*#__PURE__*/React.createElement(Button, _extends({}, getButtonAttributes(button) || {}, {
      disabled: getButtonDisabled(button),
      key: cnStatusViewButtons('item', {
        i: i
      }),
      mode: "default",
      onClick: getButtonOnClick(button),
      ref: getButtonRef(button),
      size: "l",
      tagName: getButtonTagName(button),
      view: i === 0 ? 'primary' : 'secondary-on-primary',
      width: "full"
    }), getButtonLabel(button));
  }));
};
export var StatusViewButtons = withRenderFlag({
  shouldRenderFn: function shouldRenderFn(_ref2) {
    var buttons = _ref2.buttons;
    return !!(buttons !== null && buttons !== void 0 && buttons.length);
  }
})(StatusViewButtonsRender);